export default __webpack_public_path__ + "static/media/sidebarbottom.b35fc3f6.png";